// Tiện ích xử lý hình ảnh
import api from "services/api";

// Lấy baseURL từ instance axios đã cấu hình
const API_BASE_URL = api.defaults.baseURL.replace("/api", "");

/**
 * Xử lý URL của avatar để đảm bảo đường dẫn đầy đủ
 * @param {string} avatarPath - Đường dẫn avatar từ API (ví dụ: /uploads/avatars/image.png)
 * @returns {string|null} - URL đầy đủ của avatar hoặc null nếu không có avatar
 */
export const getFullAvatarUrl = (avatarPath) => {
  if (!avatarPath) return null;

  try {
    // In ra để debug
    // Nếu đường dẫn đã là URL đầy đủ (bắt đầu bằng http hoặc https), trả về nguyên vẹn
    if (avatarPath.startsWith("http://") || avatarPath.startsWith("https://")) {
      return avatarPath;
    }

    // Xử lý đường dẫn tương đối và đảm bảo nó bắt đầu đúng cách
    let normalizedPath = avatarPath;

    // Làm sạch đường dẫn
    // Loại bỏ các ký tự đặc biệt không mong muốn và khoảng trắng trong đường dẫn
    normalizedPath = normalizedPath.trim();

    // Đảm bảo đường dẫn bắt đầu bằng /
    if (!normalizedPath.startsWith("/")) {
      normalizedPath = `/${normalizedPath}`;
    }

    // Nếu API_BASE_URL kết thúc bằng / và normalizedPath cũng bắt đầu bằng /, loại bỏ một /
    const baseUrl = API_BASE_URL.endsWith("/")
      ? API_BASE_URL.slice(0, -1)
      : API_BASE_URL;

    // Tạo URL đầy đủ
    const fullUrl = `${baseUrl}${normalizedPath}`;

    // Tạo một timestamp để tránh cache
    const timestamp = new Date().getTime();
    const finalUrl = `${fullUrl}?t=${timestamp}`;

    return finalUrl;
  } catch (error) {
    console.error("Error processing avatar URL:", error);
    return null;
  }
};

/**
 * Tạo initials (chữ cái đầu tiên) từ tên người dùng
 * @param {string} name - Tên người dùng
 * @returns {string} - Chữ cái đầu tiên của tên
 */
export const getInitials = (name) => {
  if (!name) return "?";
  return name.charAt(0).toUpperCase();
};
